export default __webpack_public_path__ + "static/media/calendar.7ed211dc.svg";